import React, { useState, useContext } from 'react';
import { Link, useNavigate }       from 'react-router-dom';
import API                         from '../services/api';
import { AuthContext }             from '../context/AuthContext';
import '../styles/Auth.css';

export default function Register() {
  const [form, setForm] = useState({
    name: '',
    email: '',
    password: '',
    role: 'warden',   // default
  });
  const { login } = useContext(AuthContext);
  const navigate  = useNavigate();

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    if (!form.email.endsWith('@bnbwu.edu.pk')) {
      return alert('Email must be an BNB University address (…@bnbwu.edu.pk)');
    }

    try {
      const { data } = await API.post('/auth/register', form);
      login(data);
      navigate(`/${data.user.role}`);
    } catch (err) {
      alert(err.response?.data?.msg || err.message);
    }
  };

  return (
    <div className="auth-container">
      <h2>📝 Staff Registration</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Name</label>
          <input
            name="name"
            value={form.name}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>BNBW University Email</label>
          <input
            type="email"
            name="email"
            value={form.email}
            onChange={handleChange}
            placeholder="you@gmail.com"
            required
          />
        </div>

        <div className="form-group">
          <label>Password</label>
          <input
            type="password"
            name="password"
            value={form.password}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Role</label>
          <select name="role" value={form.role} onChange={handleChange}>
            <option value="warden">Hostel Warden</option>
            <option value="gatekeeper">Gate Keeper</option>
          </select>
        </div>

        <button type="submit">Register Staff</button>
      </form>

      <div className="footer-text">
        Already have an account? <Link to="/login">Log In</Link><br/>
        Need a student account? <Link to="/signup">Student Sign Up</Link>
      </div>
    </div>
  );
}
